import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

const SellerEditableQuantity = ({ sale }) => {
    const { setNotification } = useNotification();
    const [data, setData] = useState({
        isEditing: false,
        quantidade: sale.quantidade ?? '0',
    });
    const [loading, setLoading] = useState(false);
    const containerRef = useRef(null);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const toggleEditing = () => {
        setData((prev) => ({
            ...prev,
            quantidade: sale.quantidade ?? '0',
            isEditing: !prev.isEditing,
        }));
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        const payload = {
            id: sale.id,
            quantidade: data.quantidade,
        };

        try {
            const response = await fetch(`${baseUrl}/manager/representantes/vendas/atualizar/${sale.id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                setData((prev) => ({
                    ...prev,
                    quantidade: sale.quantidade,
                    isEditing: false,
                }));
                throw new Error('Erro ao atualizar quantidade da venda mensal.');
            }

            setData((prev) => ({
                ...prev,
                isEditing: false,
            }));

            setNotification({
                type: 'success',
                message: 'Quantidade da venda mensal atualizada!',
                show: true,
            });
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                toggleEditing();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            {data.isEditing ? (
                <td
                    className="border w-1/6"
                    ref={containerRef}
                >
                    {loading ? (
                        <Loading className="text-primary fill-primary" />
                    ) : (
                        <form onSubmit={handleSubmit} className="relative w-full">
                            <input
                                value={data.quantidade}
                                type="number"
                                onChange={(e) =>
                                    setData((prev) => ({
                                        ...prev,
                                        quantidade: e.target.value,
                                    }))
                                }
                                className="w-full pl-4 py-4 pr-20 bg-slate-50 box-border outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                            />

                            <button
                                type="submit"
                                className="absolute right-1 bg-secondary text-white rounded-md px-2 py-1.5 top-1/2 -translate-y-1/2 text-xs"
                            >
                                <FontAwesomeIcon icon={faFloppyDisk}/> Salvar
                            </button>
                        </form>
                    )}
                </td>
            ) : (
                <td onClick={toggleEditing} className="border px-4 py-4">
                    {data.quantidade}
                </td>
            )}
        </>
    );
};

export default SellerEditableQuantity;
